<section class="slide-toggle-container">
  <p>{{labels()?.labelFalse | translate }}</p>
  <mat-slide-toggle
    color="primary"
    [checked]="defaultToggleState()"
    (change)="onToggleSlide.emit($event.checked)" />
  <p>{{labels()?.labelTrue | translate }}</p>
</section>
